import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';

import { Compiler } from '@angular/core';
import { environment } from '../environments/environment';


@Injectable()
export class AuthService {
  private headers = new HttpHeaders(
    { 
      'Content-Type': 'application/json', 
      'Disponible': '' + environment.OAUTH_DISPONIBLE, 
      'sucursal': '' + localStorage.getItem("sucursal"), 
      'empresa': '' + localStorage.getItem("empresa") 
    });

    constructor(private http: HttpClient, private router: Router, private compiler: Compiler, private _activatedRoute: ActivatedRoute, private _router: Router) { }

  login(email: string, password: string) {
    const url: string = 'signin';
    return this.http.post(`${environment.API_URL}/${url}`, {email: email, password: password}, { headers: this.headers }).pipe(map((response: HttpResponse<any>) => {
      this.compiler.clearCache();
      let json: any = response;
      if (json.access_token) {
        // Obtenemos el perfil del usuario antes iniciar sesión, para saber que configuración tenía en caso de que sea el mismo usuario
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('menu');
        localStorage.removeItem('permisos');
        localStorage.removeItem('configuracion');
        localStorage.removeItem('server_info');

        let permisos = json.permisos;
        let menu = environment.MENU;
        let menu_autorizado = [];
        // Recorremos todo el menu y quitamos los elementos a los que no se tenga autorizacion

        for (let i in menu) {
          for (let j = 0; j < menu[i].lista.length; j++) {
            if (permisos.indexOf(menu[i].lista[j].key) == -1) {
              menu[i].lista.splice(j, 1);
              j = 0;
            }
          }
        }

        menu.forEach(element => {
          if (permisos.indexOf(element.key) > -1) {
            let existe = false;
            menu_autorizado.forEach(m => {
              if (element.key == m.key) {
                existe = true;
              }
            });
            if (!existe) {
              menu_autorizado.push(element);
            }
          }
        });

        for (let i in menu) {
          for (let j = 0; j < menu[i].lista.length; j++) {
            if (permisos.indexOf(menu[i].lista[j].key) > -1) {
              if (menu_autorizado.indexOf(menu[i]) <= 0) {
                let existe = false;
                menu_autorizado.forEach(m => {
                  if (menu[i].key == m.key)
                    existe = true;
                });
                if (!existe)
                  menu_autorizado.push(menu[i]);
              }
            }
          }
        }
        let empresa = '';
        let sucursal = '';
        let nivel = '';
        if (localStorage.getItem('empresa')) {
          empresa = localStorage.getItem('empresa');
          sucursal = localStorage.getItem('sucursal');
          nivel = localStorage.getItem('nivel_educativo');
        }
        else if (json.usuario.empresas.length == 1) {
          empresa = json.usuario.empresas[0].id;
          if (json.usuario.empresas[0].sucursales.length == 1) {
            sucursal = json.usuario.empresas[0].sucursales[0].id;
          }
          nivel = json.usuario.niveles_educativos[0].id;
        }
        localStorage.setItem('token', json.access_token)
        localStorage.setItem('usuario', JSON.stringify(json.usuario));
        localStorage.setItem('configuracion', JSON.stringify(json.configuracion));
        localStorage.setItem('menu', JSON.stringify(menu_autorizado));
        localStorage.setItem('permisos', JSON.stringify(json.permisos));
        localStorage.setItem('server_info', JSON.stringify(json.server_info));

        localStorage.setItem('empresa', empresa);
        localStorage.setItem('sucursal', sucursal);
        localStorage.setItem('nivel_educativo', nivel);
      }
    }));
  }

  refreshToken() {
    const url: string = 'refresh-token?token=' + localStorage.getItem('token');
    return this.http.post(`${environment.API_URL}/${url}`, {}, { headers: this.headers }).pipe(map((response: HttpResponse<any>) => {

      let json:any = response;
      if (json.access_token) {
        localStorage.removeItem('token');
        localStorage.setItem('token', json.access_tokenetab)
      }
    }));
  }

  logout(url: string = null) {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('menu');
    localStorage.removeItem('permisos');
    localStorage.removeItem('server_info');

    this.compiler.clearCache();
    if (url != null) {
      this.router.navigate(['login'], { queryParams: { returnUrl: decodeURIComponent(url.replace(/\+/g, " ")) } });
    } else {
      this.router.navigate(['login']);
    }
  }
  empresa(url) {
    return this.http
      .post(`${environment.API_URL}/${url}`, {}, { headers: this.headers })
      .pipe(map((response: HttpResponse<any>) => {
        let json:any = response;
        localStorage.setItem("configuracion", JSON.stringify(json.data));
      }));
  }
}
